import { Mail, Facebook, Instagram, Linkedin, ArrowUp, Code2 } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  const goTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-slate-900 bg-slate-950"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <Logo size="md" />
            <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-xs">
              Agencia de diseño web local enfocada en resultados. Sucursales
              digitales que venden 24/7.
            </p>
          </div>

          <div>
            <div className="font-mono text-xs text-sky-400 mb-3">
              // contacto
            </div>
            <a
              href="mailto:isai.coria@divelopers.digital"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-slate-200 hover:text-orange-400 transition-colors"
            >
              <Mail size={16} /> isai.coria@divelopers.digital
            </a>
            <Link
              to="/portfolio"
              data-testid="footer-portfolio-link"
              className="mt-3 flex items-center gap-2 font-mono text-sm text-slate-300 hover:text-orange-400 transition-colors"
            >
              <Code2 size={16} /> Portafolio del fundador
            </Link>
          </div>

          <div>
            <div className="font-mono text-xs text-sky-400 mb-3">
              // social
            </div>
            <div className="flex items-center gap-2">
              <a
                href="#"
                data-testid="footer-social-facebook"
                aria-label="Facebook"
                className="inline-flex items-center justify-center w-10 h-10 rounded-lg border border-slate-800 text-slate-300 hover:text-sky-400 hover:border-sky-500/40 transition-colors"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
                className="inline-flex items-center justify-center w-10 h-10 rounded-lg border border-slate-800 text-slate-300 hover:text-orange-400 hover:border-orange-500/40 transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                data-testid="footer-social-linkedin"
                aria-label="LinkedIn"
                className="inline-flex items-center justify-center w-10 h-10 rounded-lg border border-slate-800 text-slate-300 hover:text-sky-400 hover:border-sky-500/40 transition-colors"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-900 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p
            data-testid="footer-copyright"
            className="font-mono text-xs text-slate-500"
          >
            © {year} &lt;Divelopers/&gt; — Todos los derechos reservados.
          </p>
          <button
            onClick={goTop}
            data-testid="footer-back-to-top"
            className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-sky-400 transition-colors"
          >
            <ArrowUp size={14} /> Volver arriba
          </button>
        </div>
      </div>
    </footer>
  );
}
